import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed-bottom-sheet"
}
const _hoisted_2 = { class: "v-container--fluid px-2 px-sm-7 pb-1 pb-md-3 pt-2 pt-md-3" }
const _hoisted_3 = {
  key: 1,
  class: "primary-link pointer d-inline-block mb-0 ml-3 f-14 font-weight-medium"
}
const _hoisted_4 = {
  key: 0,
  class: "mb-2 mb-md-0 d-block d-md-inline-block mr-0 mr-md-5 text-center"
}
const _hoisted_5 = { key: 2 }

import ShareButtons from '@/components/widgets/ShareButtons.vue';
import { useClipboard } from '@vueuse/core';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import ROUTE_NAMES from '@/constants/routeNames';

type Props = {
    visible?: boolean;
    isChosen?: boolean;
    iconSize?: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomSheetPersistent',
  props: {
    visible: { type: Boolean, default: false },
    isChosen: { type: Boolean, default: false },
    iconSize: { default: 28 }
  },
  setup(__props: any) {



const route = useRoute();
const store = useStore();

const showDownloadPDF = ref(false);

// It uses Clipboard API and falls back to document.execCommand('copy') if not supported
const { copy, copied, isSupported } = useClipboard({ legacy: true });

const shareUrl = computed<string>(() => {
    if (!route.params) return '';
    const { familyEditionId, warehouseId } = route.params;

    const url = new URL(window.location.href);
    const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH ?? '/';
    url.pathname = `${PUBLIC_PATH}rodzina/${familyEditionId}/${warehouseId}`;

    return url.href;
});

const donorLoader = computed<boolean>(() => store.getters['family/getDonorLoader']);

const isShareVisible = computed<boolean>(() => !store.getters['home/isInitStateBefore']);

const shareButtonsId = {
    fb: 'swr-step2-fb-share',
    msg: 'swr-step2-messenger-share'
} as const;

const openPrint = () => {
    window.print();
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_fade_transition = _resolveComponent("v-fade-transition")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_sheet, { elevation: "14" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                justify: "center",
                "justify-md": "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "auto",
                    md: "4",
                    class: "mb-3 mb-md-0 mt-0 mt-md-2 w-100 d-flex justify-space-around align-end align-md-center"
                  }, {
                    default: _withCtx(() => [
                      (isShareVisible.value)
                        ? (_openBlock(), _createBlock(ShareButtons, {
                            key: 0,
                            "share-url": shareUrl.value,
                            class: "d-inline-block",
                            "buttons-id": shareButtonsId,
                            "icon-size": _ctx.iconSize
                          }, null, 8, ["share-url", "icon-size"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", {
                        id: "swr-step2-print",
                        class: "primary-link pointer d-inline-block mb-0 ml-3 f-14 font-weight-medium",
                        onClick: openPrint
                      }, [
                        _createVNode(_component_v_icon, {
                          size: _ctx.iconSize,
                          color: "szViolet"
                        }, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createTextVNode(" $print ")
                          ])),
                          _: 1
                        }, 8, ["size"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('label.print')), 1)
                      ]),
                      (showDownloadPDF.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                            _createVNode(_component_v_icon, {
                              size: _ctx.iconSize,
                              color: "szViolet"
                            }, {
                              default: _withCtx(() => _cache[3] || (_cache[3] = [
                                _createTextVNode(" $filePdfBox ")
                              ])),
                              _: 1
                            }, 8, ["size"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('label.downloadPDF')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_fade_transition, { "hide-on-leave": true }, {
                        default: _withCtx(() => [
                          (_unref(isSupported))
                            ? (_openBlock(), _createElementBlock("button", {
                                id: "swr-step2-copy-url",
                                key: _unref(copied) ? _ctx.$t('label.copied') : _ctx.$t('label.copy'),
                                class: "fixed-bottom-sheet__copy primary-link pointer d-inline-block mb-0 ml-3 f-14 font-weight-medium",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(copy)(shareUrl.value)))
                              }, [
                                _createVNode(_component_v_icon, {
                                  color: "szViolet",
                                  size: _ctx.iconSize
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(copied) ? '$check' : '$copy'), 1)
                                  ]),
                                  _: 1
                                }, 8, ["size"]),
                                _createTextVNode(" " + _toDisplayString(_unref(copied) ? _ctx.$t('label.copied') : _ctx.$t('label.copy')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "auto",
                    "align-self": "center",
                    class: "fixed-bottom-sheet__right-btn-section"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isChosen)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('family.hasDonor')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isChosen)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: { name: _unref(ROUTE_NAMES).HOME },
                            class: "primary-button d-block d-md-inline-block text-center"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('family.findOtherFamily')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_v_btn, {
                              id: "swr-step2-family-choose",
                              color: "szRed",
                              loading: donorLoader.value,
                              disabled: donorLoader.value,
                              class: "primary-button my-3 my-md-0",
                              variant: "flat",
                              block: "",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('family.chooseFamily')), 1)
                              ]),
                              _: 1
                            }, 8, ["loading", "disabled"])
                          ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})